import type { StockCommandMasterEffectV1 } from '@trackeat/shared';

export interface ProductionTraceResetTarget {
  id: string;
  version?: number | null;
  archived_at?: string | null;
}

/**
 * Removes the fixed ingredient/lot snapshot when a production discharge is
 * reversed. The following draft save can then write a new provisional
 * snapshot; until that happens, trace readers cannot present reversed lots as
 * physically consumed.
 */
export function buildProductionTraceResetEffects(
  targets: readonly ProductionTraceResetTarget[],
  tenantId: string,
): StockCommandMasterEffectV1[] {
  const seen = new Set<string>();
  const effects: StockCommandMasterEffectV1[] = [];

  for (const target of targets) {
    if (target.archived_at) continue;
    if (seen.has(target.id)) {
      throw new Error(`Produzione duplicata nella riapertura: ${target.id}`);
    }
    seen.add(target.id);

    const baseVersion = target.version ?? 0;
    if (!Number.isInteger(baseVersion) || baseVersion < 0) {
      throw new Error(`Versione produzione non valida: ${target.id}`);
    }

    effects.push({
      table: 'productions',
      id: target.id,
      op: 'update',
      base_version: baseVersion,
      patch: {
        id: target.id,
        tenant_id: tenantId,
        inputs: [],
        allergens_aggregated: [],
      },
    });
  }

  return effects;
}
